import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from 'mobx-persist-store';
export default class ExchangeStore {
    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: 'ExchangeStore',
            properties: [
                'exchangeRate',
                'exchangeTransactions',
                'exchangeAnalysis'
            ]
        });
    }
    exchangeRate = [];
    exchangeTransactions = [];
    exchangeAnalysis = [];

    reset = () => {
        this.exchangeRate = [];
        this.exchangeTransactions = [];
        this.exchangeAnalysis = [];
    };

    setExchangeRate = async (state) => {
        runInAction(async () => {
            this.exchangeRate = state;
        });
    }
    setExchangeTransactions = async (state) => {
        runInAction(async () => {
            this.exchangeTransactions = state;
        });
    }
    setExchangeAnalysis = async (state) => {
        runInAction(async () => {
            this.exchangeAnalysis = state;
        });
    }
}
